import * as actions from './actions'
export type parseMessageParameters = {
  state: any;
  commit: any;
  event: any;
}



export const parseMessage= ({state, commit, event}: parseMessageParameters) => {
  if(!event.data) {
    console.warn("No data found in message");
    return;
  }

  const messagePayload = JSON.parse(event.data)
  const {type} = messagePayload
  const {layers} = messagePayload
  
  switch (type) {
    case "listLayers":
      commit(actions.SET_LAYERS, layers)
      break;
    default:
      console.warn("unexpected message type")
  }
}